import React from "react";
import {
  Grid,
  Stack,
  Box,
  Switch,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import FormTextField from "../components/common/FormTextField";
import FormSelectField from "../components/common/FormSelectField";
import SubmitButton from "../components/buttons/SubmitButton";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

import { updateFiscalIntegration } from "../redux/actions/settingsActions";

const schema = Yup.object({
  active: Yup.boolean().required(),
  environment: Yup.string().required("Environment is required"),
  deviceToken: Yup.string().nullable(),
});

const envOptions = [
  { value: "SANDBOX", label: "Sandbox (Testing)" },
  { value: "PRODUCTION", label: "Production (Live)" },
];

const UpdateFiscalIntegrationForm = ({ config, loading }) => {
  const dispatch = useDispatch();

  const isConfigured = config?.hasDeviceToken || false;

  const initialValues = {
    active: config?.active || false,
    environment: config?.environment || "SANDBOX",
    deviceToken: "",
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={(values) => {
        const payload = { ...values };
        if (!payload.deviceToken) payload.deviceToken = null; // Backend preserves existing if null
        dispatch(updateFiscalIntegration(payload));
      }}
    >
      {({ values, setFieldValue, dirty, isValid }) => (
        <Form>
          <Stack spacing={3}>
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box display="flex" alignItems="center" gap={1} mb={1}>
                    {isConfigured ? (
                      <>
                        <CheckCircleIcon color="success" fontSize="small" />
                        <Typography variant="body2" color="success.main">
                          Device Token Configured
                        </Typography>
                      </>
                    ) : (
                      <>
                        <ErrorIcon color="error" fontSize="small" />
                        <Typography variant="body2" color="error">
                          Device Token Missing
                        </Typography>
                      </>
                    )}
                  </Box>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={values.active}
                        onChange={(e) =>
                          setFieldValue("active", e.target.checked)
                        }
                        color="secondary"
                      />
                    }
                    label="Enable eTIMS Synchronization"
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormSelectField
                    name="environment"
                    label="KRA Environment"
                    options={envOptions}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormTextField
                    name="deviceToken"
                    label="Device Token (JWT)"
                    type="password"
                    multiline
                    rows={3}
                    placeholder={
                      isConfigured
                        ? "Enter a new token to override the existing one..."
                        : "eyJhbGciOiJSUz..."
                    }
                  />
                </Grid>
              </Grid>
            </Box>
            <SubmitButton
              loading={loading}
              title="Save Fiscal Settings"
              disabled={!dirty || !isValid}
              startIcon={<SaveOutlinedIcon />}
            />
          </Stack>
        </Form>
      )}
    </Formik>
  );
};
export default UpdateFiscalIntegrationForm;
